import React, { Component } from 'react'
import styles from './styles.scss'

import { TimelineMax, TweenMax, Power3, Cubic } from 'gsap'
import SplitText from 'utils/gsapPlugins/SplitText.min'

import raf from 'src/utils/raf'
import resize from 'src/utils/resize'
import values from 'src/values'
import Scroller from 'src/utils/scroller'

export default class Menu extends Component {
  constructor(props) {
    super(props)

    this.menu = []
    this.state = {
      items: []
    }
  }

  componentDidUpdate() {
    this.generateMenu()
  }

  componentWillUnMount() {
    raf.remove(this.raf)
    resize.remove(this.onResize)
  }

  addItem(obj) {
    this.menu[obj.order] = obj

    this.setState({
      items: this.menu
    })
  }

  generateMenu() {
    this.wContainer = 0
    this.wItems = []
    this.$items = []
    this.state.items.map((item, i) => {
      const wContent = this.refs[`btnFake${i}`].offsetWidth + 5
      this.wItems.push(wContent)
      const wItem = this.refs[`item${i}`].offsetWidth + 31
      this.wContainer += wItem

      TweenMax.set(this.refs[`line${i}`], {
        height: this.refs[`btnFake${i}`].offsetHeight
      })
      TweenMax.set(
        [this.refs[`overflowContainer${i}`], this.refs[`container${i}`]],
        {
          width: wContent,
          height: this.refs[`btnFake${i}`].offsetHeight
        }
      )

      this.$items.push(this.refs[`item${i}`])
    })

    TweenMax.set(this.refs.menuContainer, { width: this.wContainer })
  }

  onMouseEnter(i, e) {
    this.currentHover >= 0 && this.onMouseLeave()

    TweenMax.to(this.refs[`container${i}`], 0.5, { x: '0%' })

    this.$items.map((item, i) => {
      TweenMax.to(this.refs[`item${i}`], 0.5, { x: 0 })
    })

    if (i != this.currentItem) {
      TweenMax.to(this.refs[`container${this.currentItem}`], 0.5, {
        x: '-100%'
      })
    }

    for (let x = i + 1; x < this.state.items.length; x++) {
      TweenMax.to(this.refs[`item${x}`], 0.5, { x: this.wItems[i] })
    }

    TweenMax.to(this.refs.arrowTop, 0.5, {
      x: this.wItems[i]
    })

    this.currentHover = i
  }

  onMouseLeave() {
    if (this.currentHover === null) return

    this.refs[`container${this.currentHover}`] &&
      TweenMax.to(this.refs[`container${this.currentHover}`], 0.5, {
        x: '-100%'
      })

    for (let x = this.currentHover + 1; x < this.state.items.length; x++) {
      TweenMax.to(this.refs[`item${x}`], 0.5, { x: 0 })
    }

    this.defaultState()

    this.currentHover = null
  }

  setMenu(i, update) {
    if (i === this.currentItem && this.menuVisible) return

    if (
      update &&
      this.currentItem >= 0 &&
      this.refs[`container${this.currentItem}`]
    ) {
      TweenMax.to(this.refs[`container${this.currentItem}`], 0.5, {
        x: '-100%'
      })
    }
    this.currentItem = i

    if (this.currentHover === null) {
      this.$items.map((item, i) => {
        TweenMax.to(this.refs[`item${i}`], 0.5, { x: 0 })
      })

      this.refs[`container${this.currentHover}`] &&
        TweenMax.to(this.refs[`container${this.currentHover}`], 0.5, {
          x: '-100%'
        })
    }

    if (update) {
      if (
        this.currentItem <= this.state.items.length - 1 &&
        !this.btnBtmVisible
      ) {
        this.btnBtmVisible = true
        TweenMax.to(this.refs.arrowBtm, 0.5, {
          autoAlpha: 1,
          ease: Power3.easeOut
        })
      }

      if (this.currentItem === 0 && this.btnBtmVisible) {
        this.btnBtmVisible = false
        TweenMax.to(this.refs.arrowBtm, 0.5, {
          autoAlpha: 0,
          ease: Power3.easeOut
        })
      }

      if (
        this.currentItem === this.state.items.length - 1 &&
        this.btnTopVisible
      ) {
        this.btnTopVisible = false
        TweenMax.to(this.refs.arrowTop, 0.5, {
          autoAlpha: 0,
          ease: Power3.easeOut
        })
      }

      if (
        this.currentItem < this.state.items.length - 1 &&
        !this.btnTopVisible
      ) {
        this.btnTopVisible = true
        TweenMax.to(this.refs.arrowTop, 0.5, {
          autoAlpha: 1,
          ease: Power3.easeOut
        })
      }
    }

    this.defaultState()
  }

  defaultState() {
    if (!this.refs[`item${this.currentItem}`]) return

    for (let x = this.currentItem + 1; x < this.state.items.length; x++) {
      this.refs[`item${x}`] &&
        TweenMax.to(this.refs[`item${x}`], 0.5, {
          x: this.wItems[this.currentItem]
        })
    }

    TweenMax.to(this.refs.arrowTop, 0.5, {
      x: this.wItems[this.currentItem]
    })

    TweenMax.to(this.refs[`item${this.currentItem}`], 0.5, {
      x: 0
    })

    this.refs[`container${this.currentItem}`] &&
      TweenMax.to(this.refs[`container${this.currentItem}`], 0.5, {
        x: '0%'
      })

    TweenMax.to(this.refs.component, 0.5, {
      y: this.wItems[this.currentItem] / 2
    })

    this.menuVisible = true
  }

  goToBlock(i, set, e) {
    Scroller.scrollTo(
      set
        ? this.state.items[this.currentItem + i].top - 70
        : this.state.items[i].top - 70
    ).then()
  }

  whiteMenu() {
    this.refs.component.classList.add('white')
  }

  defaultMenu() {
    this.refs.component.classList.remove('white')
  }

  render() {
    return (
      <div ref="component" className="component menu ">
        <div
          ref="menuContainer"
          className="menu-container"
          onMouseLeave={this.onMouseLeave.bind(this)}>
          <span
            onClick={this.goToBlock.bind(this, +1, true)}
            ref="arrowTop"
            className="arrow arrow-top">
            <span className="middle" />
            <span className="top" />
            <span className="btm" />
          </span>
          {this.state.items.map((item, i) => {
            return (
              <div
                key={`item${i}`}
                ref={`item${i}`}
                className="item"
                style={{ zIndex: i }}>
                <span ref={`line${i}`} className="line">
                  <span
                    onClick={this.goToBlock.bind(this, i, false)}
                    onMouseEnter={this.onMouseEnter.bind(this, i)}
                    className="hover-line"
                  />
                  <span className="l-line" />
                </span>
                <div
                  ref={`overflowContainer${i}`}
                  className="overflow-container">
                  <div
                    onClick={this.goToBlock.bind(this, i, false)}
                    ref={`container${i}`}
                    className="container">
                    <p ref={`btn${i}`} className="btn">
                      {item.legend}
                    </p>
                  </div>
                </div>
              </div>
            )
          })}
          <span
            onClick={this.goToBlock.bind(this, -1, true)}
            ref="arrowBtm"
            className="arrow arrow-btm">
            <span className="middle" />
            <span className="top" />
            <span className="btm" />
          </span>
        </div>

        <div ref="itemsFake" className="items-f">
          {this.state.items.map((item, i) => {
            return (
              <p ref={`btnFake${i}`} key={`btnFake${i}`} className="btn btn-f">
                {item.legend}
              </p>
            )
          })}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/components/menu/index.js